import MyButtonSpinner from 'components/common/my-components/MyButtonSpinner';
import { Field, Form as FormFormik, Formik } from 'formik';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { FiCreditCard, FiMail, FiUserCheck } from 'react-icons/fi';
import { TbLicense } from 'react-icons/tb';
import { useDispatch } from 'react-redux';
import { createMatriculado, getMatriculados } from 'redux/matriculadosSlice';
import { userMatriculadoCreateSchema } from '../validations/matriculadoCreateSchema';

export const CreateMatriculadoForm = ({ setModalShow }) => {
  const dispatch = useDispatch();
  const [loadingButton, setLoadingButton] = useState(false);

  const handleSubmit = async values => {
    if (loadingButton) {
      return null;
    } else {
      setLoadingButton(true);

      let userData = {
        nombre: values.nombre,
        apellido: values.apellido,
        email: values.email,
        dni: values.dni,
        matricula: values.matricula
      };

      try {
        dispatch(createMatriculado(userData))
          .then(response => {
            if (response && response.status < 400) {
              setModalShow && setModalShow(false);
              dispatch(getMatriculados({}, 0, 10, ''));
            } else {
              console.error(
                'Error al guardar un matriculado: ',
                'Respuesta del servidor con status >= 400'
              );
            }
          })
          .catch(err => {
            console.error('Error al guardar un matriculado: ', err);
          })
          .finally(() => {
            setLoadingButton(false);
          });
      } catch (err) {
        console.error('Error al despachar la acción createMatriculado: ', err);
      }
    }
  };

  return (
    <Formik
      initialValues={{
        nombre: '',
        apellido: '',
        email: '',
        dni: '',
        matricula: ''
      }}
      validationSchema={userMatriculadoCreateSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <FormFormik>
          <Row className="g-3">
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>
                  <FiUserCheck /> Nombre
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="nombre"
                  type="text"
                  placeholder="Ingresa un nombre"
                  isInvalid={errors.nombre && touched.nombre}
                />
                {errors.nombre && touched.nombre && (
                  <p className="text-danger small m-0">{errors.nombre}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>
                  <FiUserCheck /> Apellido
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="apellido"
                  type="text"
                  placeholder="Ingresa un apellido"
                  isInvalid={errors.apellido && touched.apellido}
                />
                {errors.apellido && touched.apellido && (
                  <p className="text-danger small m-0">{errors.apellido}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>
                  <FiCreditCard /> DNI
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="dni"
                  type="text"
                  placeholder="Ingresa un DNI"
                  isInvalid={errors.dni && touched.dni}
                />
                {errors.dni && touched.dni && (
                  <p className="text-danger small m-0">{errors.dni}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>
                  <TbLicense /> Matrícula
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="matricula"
                  type="number"
                  placeholder="Ingresa la matrícula"
                  isInvalid={errors.matricula && touched.matricula}
                />
                {errors.matricula && touched.matricula && (
                  <p className="text-danger small m-0">{errors.matricula}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12}>
              <Form.Group>
                <Form.Label>
                  <FiMail /> Email
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="email"
                  type="email"
                  placeholder="Ingresa un email"
                  isInvalid={errors.email && touched.email}
                />
                {errors.email && touched.email && (
                  <p className="text-danger small m-0">{errors.email}</p>
                )}
              </Form.Group>
            </Col>

            <Col xs={12}>
              {!loadingButton ? (
                <Button
                  variant="success"
                  type="submit"
                  className="w-100"
                  disabled={
                    !!errors.nombre ||
                    !!errors.apellido ||
                    !!errors.email ||
                    !!errors.dni ||
                    !!errors.matricula ||
                    loadingButton
                  }
                >
                  Registrar Matriculado
                </Button>
              ) : (
                <MyButtonSpinner className="w-100" />
              )}
            </Col>
          </Row>
        </FormFormik>
      )}
    </Formik>
  );
};

CreateMatriculadoForm.propTypes = {
  modalShow: PropTypes.bool,
  setModalShow: PropTypes.func
};
